import { render } from "./VideoComponent.vue?vue&type=template&id=78d06503&ts=true"
import script from "./VideoComponent.vue?vue&type=script&lang=ts"
export * from "./VideoComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__